import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Line } from 'react-lineto';
import { convertText } from '../../common/node'

export class BaseDot extends Component {

  render() {
    const { id, number, client, server, x, y, px, py } = this.props
    if(typeof id === 'undefined'){
      return ( null )
    }

    return(
      <div>
        <Line x0={(x/3 || client.x[number]/3)+6+(window.innerWidth/3)}
          y0={(y/3 || client.y[number]/3)+6+(window.innerHeight/3)}
          x1={px/3+6+(window.innerWidth/3)} y1={py/3+6+(window.innerHeight/3)}
          border='1px solid #606060' zIndex={1} />
        <div className='dot-base'
          style={{
            transform: `translate3d(
            ${(x/3 || client.x[number]/3)+(window.innerWidth/3)}px,
            ${(y/3 || client.y[number]/3)+(window.innerHeight/3)}px,
            0px)`,}}>
            { (id in server.mine)
                ? (
                  <div>
                    <div className='dot red-dot' />
                    <div className='pulse red-pulse' />
                  </div>
                )
                : (
                  <div>
                    <div className='dot' />
                    <div className='pulse' />
                  </div>
                )
            }
            <span class="dot-balloon">{convertText(server.contents[id]['text'])}</span>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseDot)



// WEBPACK FOOTER //
// ./src/components/dots/BaseDot.js